import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionService } from '../../services/permission/permission.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { CheckinDialogComponent } from './checkin-dialog/checkin-dialog.component';

@Component({
  selector: 'app-frontdesk-checkin-desk',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './frontdesk-checkin-desk.component.html',
  styleUrls: ['./frontdesk-checkin-desk.component.scss', '../../../common-style/dropdown.scss'],
})
export class FrontdeskCheckinDeskComponent implements OnInit {
  premises = new FormControl<number | null>(null);
  date = new FormControl('');
  familyCode = new FormControl('');
  bookingId = new FormControl('');

  premisesList: any[] = [];
  groups: any[] = [];
  hasSearched: boolean = false;
  isLoading: boolean = false;
  canCheckin: boolean = false;

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService,
    private permissionService: PermissionService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.canCheckin = this.permissionService.can('checkin-desk', 'can_checkin');
    this.loadPremises();
  }

  loadPremises(): void {
    this.frontdeskService.fetchPremises().subscribe({
      next: (res: any) => (this.premisesList = res?.data || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load premises.'),
    });
  }

  search(): void {
    if (!this.premises.value) {
      this.toastService.error('Select a premises.');
      return;
    }
    const payload = {
      premises: this.premises.value,
      date: this.date.value || null,
      familyCode: this.familyCode.value || null,
      bookingId: this.bookingId.value ? Number(this.bookingId.value) : null,
    };
    this.isLoading = true;
    this.frontdeskService.fetchCheckinList(payload).subscribe({
      next: (res: any) => {
        this.groups = res?.data?.checkinDetails || [];
        this.hasSearched = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.groups = [];
        this.hasSearched = true;
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load check-in list.');
      },
    });
  }

  checkIn(row: any): void {
    const ref = this.dialog.open(CheckinDialogComponent, {
      width: '680px',
      maxWidth: '95vw',
      data: {
        requisitionId: row.requisitionId,
        familyCode: row.familyCode,
        name: row.primaryApplicantName,
      },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.search();
    });
  }
}
